import { SelectItem } from '@ftr/forms'
import { ApiResult, Icon } from '@ftr/foundation'
import { Observable } from 'rxjs'
import { ComplexFilter, ComplexFilterSearchable } from './ComplexFilter'

interface CheckboxTreeDataItem {
  id: string
  name: string
}

export interface CheckboxTreeData extends CheckboxTreeDataItem {
  children: CheckboxTreeDataItem[]
}

export class CheckboxTreeFilter<T extends string = string> extends ComplexFilter {
  options: () => ApiResult<CheckboxTreeData[]>
  searchable?: ComplexFilterSearchable

  constructor(
    filterKey: string,
    collapsible: boolean,
    icon: Icon,
    options: () => ApiResult<CheckboxTreeData[]>,
    title?: string | Observable<string>,
    searchable?: ComplexFilterSearchable,
    maxSelectedOptions?: number,
    defaultValue?: T,
    noClear?: boolean,
    hiddenOptions?: SelectItem<T>[],
    isEnabled?: Observable<boolean>,
  ) {
    super('checkbox-tree', filterKey, collapsible, icon, title, defaultValue, noClear, hiddenOptions, isEnabled)
    this.options = options
    this.searchable = searchable
    this.maxSelectedOptions = maxSelectedOptions
  }
}
